import { PRODUCT_CATEGORIES_INFO, PRODUCT_CATEGORIES_REPORTS_UNITS, ProductReport } from '@prodcard/core'
import { Workbook } from 'exceljs'

export function createSheetProductPlan(workbook: Workbook, sheetName: string, productReports: ProductReport[]) {
  const worksheet = workbook.addWorksheet(sheetName)
  worksheet.columns = [
    { header: 'Прод. категория', width: 30 },
    { header: 'Поставка', width: 20 },
    { header: 'Фактическое потребление', width: 20 },
    { header: 'Остаток/Потребность', width: 20 },
  ]

  productReports.forEach(productReport => {
    worksheet.addRow([
      `${PRODUCT_CATEGORIES_INFO[productReport.category].description} ${
        PRODUCT_CATEGORIES_REPORTS_UNITS[productReport.category] || ''
      }`,
      productReport.supply,
      productReport.consumption,
      productReport.balance,
    ])
  })
}
